
import { Card, Col, Row, Typography, theme, Spin, ConfigProvider, Flex, Button, Layout } from "antd"
import { Link } from "react-router-dom"
import { useGetSharedLinks } from "../../api/moneyflow/moneyflow"
import MoneyFlowLogo from '../../assets/MoneyFlow_logo.svg?react'
import { MoonOutlined, SunOutlined } from "@ant-design/icons"
import { getAntdTheme } from "../../theme/antdTheme.ts"
import { useDarkMode } from "../../hooks/useDarkMode.tsx"

const { Title } = Typography

export const SharedLinksPage = () => {
    // Same theme store as the rest of the app (and the cookie banner), not a page-local default
    const { darkModeEnabled: darkMode, switchDarkMode: toggleDarkMode } = useDarkMode()
    const { data: sharedLinks, isLoading } = useGetSharedLinks()
    const { token } = theme.useToken()

    if (isLoading) {
        return <Spin style={{ display: "block", margin: "auto" }} />
    }

    return (
        <ConfigProvider theme={getAntdTheme(darkMode)}>
            <Layout style={{ height: '100vh', width: '100%', padding: token.paddingLG }}>
                <Flex justify="space-between" align="center" >
                    <a style={{ display: 'inline-block', width: '300px' }} href="https://lite.bitquery.io/" title="MoneyFlow Lite"><MoneyFlowLogo width={189} height={60} style={{ color: 'var(--ant-color-text)' }} /></a>
                    <Button title={darkMode ? 'Light Mode' : 'Dark Mode'} icon={darkMode ? <MoonOutlined /> : <SunOutlined />} onClick={toggleDarkMode} />
                </Flex>
                <Title level={2}>Explore Trending MoneyFlows</Title>
                <Typography.Paragraph>
                    Discover what others are exploring right now. Dive into the most popular shared addresses and stay updated with the latest trends in blockchain activity.
                </Typography.Paragraph>
                <Row style={{ width: '100%', overflow: 'scroll' }} gutter={[token.marginXS, token.marginXS]}>
                    {sharedLinks?.map((link) => (
                        <Col key={link.originalId} >
                            <Card
                                title={link.name}
                                extra={<Link to={`/share/${link.originalId}/${link.name}`}>View</Link>}
                                style={{ borderRadius: token.borderRadius, width: "500px" }}
                            >
                                <a href={`/share/${link.originalId}/${link.name}`}>
                                    <img
                                        alt={link.name}
                                        src={`/public/get-preview/${link.originalId}`}
                                        style={{
                                            height: 200,
                                            width: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                </a>
                                <p><strong>Address:</strong> {link.address}</p>
                                <p><strong>Blockchain:</strong> {link.network}</p>
                                {link.createdAt && <p>
                                    <strong>Created:</strong> {new Date(link.createdAt).toLocaleDateString()}
                                </p>}
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Layout>
        </ConfigProvider>
    )
}
